import { render } from "./wxlogin.vue?vue&type=template&id=5bc7156c&scoped=true&ts=true"
import script from "./wxlogin.vue?vue&type=script&lang=ts"
export * from "./wxlogin.vue?vue&type=script&lang=ts"

import "./wxlogin.vue?vue&type=style&index=0&id=5bc7156c&lang=less&scoped=true"

import exportComponent from "/root/workspace/LiYuLoginSaaS_ql2g/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc7156c"]])

export default __exports__